'use strict';

var enumerate = require('../../lib/enumerate');

module.exports = enumerate([
  'AUTHENTICATION_COMPLETE'
], 'threedsecure:');



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/three-d-secure/shared/events.js
// module id = 818
// module chunks = 0